export default __webpack_public_path__ + "static/media/Location_Baden-Wurttemberg.63ec7899.svg";